import React from 'react';
import FormFooter from '../../../common/FormFooter';
import { VerifiedGrossFormProps } from '../../../../../../interfaces/VerifiedGross';
import UploadLogo from '../../../common/UploadLogo';
import { Checkbox, FormControl, FormControlLabel, Grid } from '@mui/material';
import NewCustomSelect from '../../../../../newcustomselect/newcustomselect';
import CustomTextField from '../../../../../CustomTextInput';
import Customdatepicker from '../../../../../customdatepicker/customdatepicker';
import Signature from '../../../../../signature/signature';

export const VerifiedGrossMobileForm = ({
    updateField,
    payload,
    corporatePartners,
    methodOne,
    methodTwo,
    loadingCorporatepartners,
    setShowAddPartner,
    errors,
    handleChangeOne,
    handleChangeTwo,
    setSignatureUrlBase64,
    signatureUrlBase64,
    updateQuoteField,
    showPreview,
    setShowPreview,
    onSaveOnlyAction,
    activeStep,
    setActiveStep
}: VerifiedGrossFormProps) => {
    return (
        <div className='lg:hidden pt-2'>
            <div className='w-full flex flex-col gap-1'>
                <UploadLogo {...{ payload, updateField }} />
                <Grid container>
                    <Grid item xs={12} md={12} lg={6}>
                        <div className=' pt-[0.1rem] h-full'>
                            <div className='mt-2'>
                                <NewCustomSelect
                                    hasError={errors?.shipperId.length > 0}
                                    helperText={
                                        errors?.shipperId.length > 0
                                            ? errors?.shipperId
                                            : undefined
                                    }
                                    selectValue={payload.shipperId}
                                    required
                                    selectOptions={
                                        corporatePartners as unknown as (
                                            | string
                                            | Record<string, unknown>
                                        )[]
                                    }
                                    name={'shipperId'}
                                    updateField={(_, value) => {
                                        updateField('shipperId', value);
                                        updateField(
                                            'shipperAddress',
                                            corporatePartners.filter(
                                                (item: any) =>
                                                    item?.id === value
                                            )[0]?.address
                                        );
                                        updateField(
                                            'shipperBank',
                                            corporatePartners.filter(
                                                (item: any) =>
                                                    item?.id === value
                                            )[0]?.bankName
                                        );

                                        updateField(
                                            'shipperSwiftCode',
                                            corporatePartners.filter(
                                                (item: any) =>
                                                    item?.id === value
                                            )[0]?.swiftCode
                                        );
                                    }}
                                    label={'Shipper'}
                                    selectOptionLabel='name'
                                    loading={loadingCorporatepartners}
                                    dropdownRender={() => {
                                        return (
                                            <div className='px-4 border-t border-appcolorgreyfaint'>
                                                <p
                                                    className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                                    onClick={() => {
                                                        setShowAddPartner(true);
                                                    }}
                                                >
                                                    + Add a New Partner
                                                </p>
                                            </div>
                                        );
                                    }}
                                />
                            </div>
                            <div className='mt-4'>
                                <CustomTextField
                                    error={errors?.shipperAddress.length > 0}
                                    helperText={
                                        errors?.shipperAddress.length > 0
                                            ? errors?.shipperAddress
                                            : undefined
                                    }
                                    value={payload?.shipperAddress}
                                    required
                                    id='quotation-exporterAddress'
                                    label='Shipper Address'
                                    name='shipperAddress'
                                    onChange={(e: any) => {
                                        updateField(
                                            'shipperAddress',
                                            e.target.value
                                        );
                                    }}
                                />
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>
                        <div className='pt-[1rem] h-full'>
                            <Grid
                                container
                                spacing={1}
                                sx={{
                                    marginTop: '0px'
                                }}
                            >
                                <Grid item xs={12} md={12} lg={12}>
                                    <CustomTextField
                                        error={
                                            errors?.shipperReference.length > 0
                                        }
                                        helperText={
                                            errors?.shipperReference.length > 0
                                                ? errors?.shipperReference
                                                : undefined
                                        }
                                        required
                                        id='quotation-shipperReference'
                                        label="Shipper's Reference"
                                        name='shippers'
                                        value={payload.shipperReference}
                                        onChange={(e: any) => {
                                            updateField(
                                                'shipperReference',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12} lg={12}>
                                    <div className='mt-4'>
                                        <CustomTextField
                                            error={
                                                errors?.certificateNumber
                                                    .length > 0
                                            }
                                            helperText={
                                                errors?.certificateNumber
                                                    .length > 0
                                                    ? errors?.certificateNumber
                                                    : undefined
                                            }
                                            required
                                            value={payload.certificateNumber}
                                            id='quotation-certificateNumber'
                                            label='Certificate Number'
                                            name='certificateNumber'
                                            onChange={(e: any) => {
                                                updateField(
                                                    'certificateNumber',
                                                    e.target.value
                                                );
                                            }}
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>

                    <Grid item xs={12} md={12} lg={6}>
                        <div className='mt-4'>
                            <CustomTextField
                                error={errors?.billOfLadingNumber.length > 0}
                                helperText={
                                    errors?.billOfLadingNumber?.length > 0
                                        ? errors?.billOfLadingNumber
                                        : undefined
                                }
                                value={payload?.billOfLadingNumber}
                                required
                                id='quotation-billOfLadingNumber'
                                label='Bill of Lading Number'
                                name='billOfLadingNumber'
                                onChange={(e: any) => {
                                    updateField(
                                        'billOfLadingNumber',
                                        e.target.value
                                    );
                                }}
                            />
                        </div>
                    </Grid>

                    <FormControl>
                        <div className='border border-appcolorgreyfaint mt-[1rem] p-[1rem] flex items-start rounded-lg '>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={handleChangeOne}
                                        name='methodOne'
                                        checked={methodOne}
                                        color='secondary'
                                        sx={{
                                            paddingTop: 0
                                        }}
                                    />
                                }
                                label=''
                                sx={{ marginRight: 0, padding: 0 }}
                            />
                            <div className='pl-2'>
                                <p className='font-bold text-appcolorblacktwo text-[14px] opacity-[0.6] pb-2 leading-[16px]'>
                                    METHOD 1
                                </p>
                                <p className='text-appcolorblacktwo text-[14px] leading-[16px] opacity-[0.6] '>
                                    Weighing the packed container using
                                    calibrated and certified weighing wquipment
                                    (e.g. weighbridges, load cell sensing
                                    technologies etc).
                                </p>
                            </div>
                        </div>

                        <div className='border border-appcolorgreyfaint mt-[1rem] p-[1rem] flex items-start rounded-lg '>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        onChange={handleChangeTwo}
                                        name='methodOne'
                                        checked={methodTwo}
                                        color='secondary'
                                        sx={{
                                            paddingTop: 0
                                        }}
                                    />
                                }
                                label=''
                                sx={{ marginRight: 0, padding: 0 }}
                            />{' '}
                            <div className='pl-2'>
                                <p className='font-bold text-appcolorblacktwo text-[14px] opacity-[0.6] pb-2 leading-[16px]'>
                                    METHOD 2
                                </p>
                                <p className='text-appcolorblacktwo text-[14px] opacity-[0.6] leading-[16px]'>
                                    Weighing all packages and cargo items,
                                    including the mass of pallets, dunnage and
                                    other securing material to be packed in the
                                    container and adding the tare mass of the
                                    container to the sum of the single masses,
                                    using a certified method approved by the
                                    Country competent Authority (Marine and
                                    Coastguard Agency (MCA) or its authorized
                                    body).
                                </p>
                            </div>
                        </div>
                    </FormControl>

                    <Grid item xs={12} md={12} lg={3}>
                        <div className='pt-[1rem]'>
                            <CustomTextField
                                error={errors?.containerNumber.length > 0}
                                helperText={
                                    errors?.containerNumber.length > 0
                                        ? errors?.containerNumber
                                        : undefined
                                }
                                id='verifiedgrossmassdeclaration--containerNumber'
                                label='Container Number'
                                name='containerNumber'
                                value={payload.containerNumber}
                                onChange={(e: any) => {
                                    updateField(
                                        'containerNumber',
                                        e.target.value
                                    );
                                    updateQuoteField(
                                        0,
                                        'containerNumber',
                                        e.target.value
                                    );
                                }}
                            />
                        </div>
                    </Grid>

                    <Grid item xs={12} md={12} lg={3}>
                        <div className='pt-[1rem]'>
                            <CustomTextField
                                error={errors?.containerTare.length > 0}
                                helperText={
                                    errors?.containerTare.length > 0
                                        ? errors?.containerTare
                                        : undefined
                                }
                                id='verifiedgrossmassdeclaration--containerTare'
                                label='Container Tare (kg)'
                                name='containerTare'
                                value={payload.containerTare}
                                onChange={(e: any) => {
                                    updateField(
                                        'containerTare',
                                        e.target.value
                                    );
                                    updateQuoteField(
                                        0,
                                        'containerTare',
                                        e.target.value
                                    );
                                }}
                            />
                        </div>
                    </Grid>

                    <Grid item xs={12} md={12} lg={3}>
                        <div className='pt-[1rem]'>
                            <CustomTextField
                                error={errors?.cargoWeight.length > 0}
                                helperText={
                                    errors?.cargoWeight.length > 0
                                        ? errors?.cargoWeight
                                        : undefined
                                }
                                value={payload.cargoWeight}
                                id='verifiedgrossmassdeclaration--cargoWeight'
                                label='Cargo Weight (kg)'
                                name='cargoWeight'
                                onChange={(e: any) => {
                                    updateField('cargoWeight', e.target.value);
                                    updateQuoteField(
                                        0,
                                        'cargoWeight',
                                        e.target.value
                                    );
                                }}
                            />
                        </div>
                    </Grid>

                    <Grid item xs={12} md={12} lg={3}>
                        <div className='pt-[1rem]'>
                            <CustomTextField
                                error={errors?.grossWeight.length > 0}
                                helperText={
                                    errors?.grossWeight.length > 0
                                        ? errors?.grossWeight
                                        : undefined
                                }
                                id='verifiedgrossmassdeclaration-grossWeight'
                                label='Gross Weight (kg)'
                                name='grossWeight'
                                onChange={(e: any) => {
                                    updateField('grossWeight', e.target.value);
                                    updateQuoteField(
                                        0,
                                        'grossWeight',
                                        e.target.value
                                    );
                                }}
                                value={payload.grossWeight}
                            />
                        </div>
                    </Grid>

                    <Grid item xs={12} md={12} lg={6}>
                        <div className='pt-[1rem]'>
                            <CustomTextField
                                multiline
                                rows={2.8}
                                height={150}
                                id='quotation-additionalInformation'
                                label='Additional Information'
                                name='additionalInformation'
                                onChange={(e: any) => {
                                    updateField(
                                        'additionalInformation',
                                        e.target.value
                                    );
                                }}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>
                        <div className='pt-[1rem]'>
                            <Grid
                                container
                                spacing={1}
                                sx={{
                                    marginTop: '0px'
                                }}
                            >
                                <Grid item xs={12} md={12} lg={6}>
                                    <CustomTextField
                                        error={errors?.placeOfIssue.length > 0}
                                        helperText={
                                            errors?.placeOfIssue.length > 0
                                                ? errors?.placeOfIssue
                                                : undefined
                                        }
                                        required
                                        id='quotation-placeOfIssue'
                                        label='Place of Issue'
                                        name='placeOfIssue'
                                        value={payload.placeOfIssue}
                                        onChange={(e: any) => {
                                            updateField(
                                                'placeOfIssue',
                                                e.target.value
                                            );
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12} lg={6}>
                                    <div className='pt-4'>
                                        <Customdatepicker
                                            id='quotation-issuedDate'
                                            label='Date of Issue'
                                            name='issuedDate'
                                            updateField={updateField}
                                            error={
                                                errors?.issuedDate.length > 0
                                            }
                                            helperText={
                                                errors?.issuedDate.length > 0
                                                    ? errors?.issuedDate
                                                    : undefined
                                            }
                                            value={
                                                payload?.issuedDate !==
                                                undefined
                                                    ? payload?.issuedDate
                                                    : null
                                            }
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12} lg={12}>
                                    <div className='pt-[1rem]'>
                                        <CustomTextField
                                            error={
                                                errors?.signatoryCompany
                                                    .length > 0
                                            }
                                            helperText={
                                                errors?.signatoryCompany
                                                    .length > 0
                                                    ? errors?.signatoryCompany
                                                    : undefined
                                            }
                                            required
                                            value={payload.signatoryCompany}
                                            id='quotation-signatoryCompany'
                                            label='Signatory Company'
                                            name='signatoryCompany'
                                            onChange={(e: any) => {
                                                updateField(
                                                    'signatoryCompany',
                                                    e.target.value
                                                );
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12} lg={12}>
                                    <div className='pt-[1rem]'>
                                        <CustomTextField
                                            error={
                                                errors
                                                    ?.nameOfAuthorisedSignatory
                                                    .length > 0
                                            }
                                            helperText={
                                                errors
                                                    ?.nameOfAuthorisedSignatory
                                                    .length > 0
                                                    ? errors?.nameOfAuthorisedSignatory
                                                    : undefined
                                            }
                                            required
                                            id='quotation-nameOfAuthorisedSignatory'
                                            label='Name of Authorized Signature'
                                            name='nameOfAuthorisedSignatory'
                                            onChange={(e: any) => {
                                                updateField(
                                                    'nameOfAuthorisedSignatory',
                                                    e.target.value
                                                );
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item xs={12} md={12} lg={12}>
                                    <div className='w-full mt-4'>
                                        <Signature
                                            name='signatureUrl'
                                            updateField={updateField}
                                            setSignatureUrlBase64={
                                                setSignatureUrlBase64
                                            }
                                            signatureUrlBase64={
                                                signatureUrlBase64
                                            }
                                        />
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </div>
            <FormFooter
                onContinue={() => {
                    setActiveStep(activeStep + 1);
                    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                }}
                onSave={() => onSaveOnlyAction && onSaveOnlyAction()}
                onPreview={() => setShowPreview(!showPreview)}
                onGoBack={() => {
                    setActiveStep(activeStep - 1);
                    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                }}
                steps={1}
                activeStep={activeStep}
                disabled={Object.values(payload).some(
                    (item) => item === undefined
                )}
            />
        </div>
    );
};
